import { Router, Route, RouteProps, Switch } from "react-router-dom";
import Search from "./pages/Search/Search";
import Checkin from "./pages/Checkin/Checkin";
import Receiving from "./pages/Receiving/Receiving";
import ReceiveListByStatus from "./pages/ReceiveListByStatus/ReceiveListByStatus";
import PendingCreditRequest from "./pages/CreditRequest/PendingCreditRequests";
import Settings from "./pages/Settings/Settings";
import EdiLikeAManualReceiving from "./pages/Receiving/EdiLikeAManualReceiving";
import CreditRequest from "./pages/CreditRequest/CreditRequest";
import CreditRequestDetail from "./pages/CreditRequest/CreditRequestDetail";
import NewAdhocCreditRequest from "./pages/CreditRequest/NewAdhocCreditRequest";
import AsnSearch from "./pages/AsnSearch/AsnSearch";
import React, { useContext } from "react";
import PageContext from "./components/Common/PageContext";
import { UserContext } from "./providers/user";
import NoAccess from "./components/NoAccess/NoAccess";
import ProductLabels from "./pages/Labels/ProductLabels";
import TagSheetLabels from "./pages/Labels/TagSheetLabels";
import TransferListPage from "./pages/Transfers/TransferListPage";
import ReceiveTransfer from "./pages/TransferReceiving/ReceiveTransfer";
import ReceiveManual from "./pages/Receiving/ManualReceiving";
import OutstandingEdiByDate from "./pages/OutstandingEdiInvoices/OutstandingEdiByDate";
import OutstandingEdiInvoiceDetails from "./pages/OutstandingEdiInvoices/OutstandingEdiInvoiceDetails";
import CreditRequestSearch from "./pages/CreditRequest/CreditRequestSearch";

export const AppRouter: React.FC<any> = (props) => {
	const [pageContext] = React.useContext(PageContext);
	const { userLocation } = pageContext;
	const { history } = props;
	const { graphProfile, account } = useContext(UserContext);
	const userDetails = {
		graphProfile,
		account,
	};

	if (graphProfile.roles.length > 0) {
		return (
			<Router history={history}>
				<Switch>
					<Route
						path="/"
						exact
						render={(routeProps: RouteProps) => <Search {...{ ...routeProps, ...props, ...userDetails }} />}
					/>
					<Route
						path="/Checkin"
						exact
						render={(routeProps: RouteProps) => (
							<Checkin {...{ ...routeProps, ...props, userLocation: userLocation, ...userDetails }} />
						)}
					/>
					<Route
						path="/Receiving"
						exact
						render={(routeProps: RouteProps) => <Receiving {...{ ...routeProps, ...props, ...userDetails }} />}
					/>
					<Route path="/ManualReceiving" exact render={(routeProps: RouteProps) => <ReceiveManual />} />
					<Route
						path="/Receives"
						exact
						render={(routeProps: RouteProps) => (
							<ReceiveListByStatus {...{ ...routeProps, ...props, ...userDetails }} />
						)}
					/>
					<Route
						path="/CreditRequests"
						exact
						render={(routeProps: RouteProps) => (
							<PendingCreditRequest {...{ ...routeProps, ...props, ...userDetails }} />
						)}
					/>
					<Route
						path="/Settings"
						exact
						render={(routeProps: RouteProps) => <Settings {...{ ...routeProps, ...props, ...userDetails }} />}
					/>
					<Route
						path="/EdiLikeAManualReceiving"
						exact
						render={(routeProps: RouteProps) => (
							<EdiLikeAManualReceiving {...{ ...routeProps, ...props, ...userDetails }} />
						)}
					/>
					<Route
						path="/CreditRequest"
						exact
						render={(routeProps: RouteProps) => <CreditRequest {...{ ...routeProps, ...props, ...userDetails }} />}
					/>
					<Route
						path="/CreditRequest/Detail"
						render={(routeProps: RouteProps) => (
							<CreditRequestDetail {...{ ...routeProps, ...props, ...userDetails }} />
						)}
					/>
					<Route
						path="/creditRequests/adhoc"
						exact
						render={(routeProps: RouteProps) => (
							<NewAdhocCreditRequest {...{ ...routeProps, ...props, userLocation: userLocation, ...userDetails }} />
						)}
					/>
					<Route 
						path="/creditRequests/search"
						exact
						render={(routeProps: RouteProps) => (
							<CreditRequestSearch {...{ ...routeProps, ...props, ...userDetails }}/>
						)}
					/>
					<Route path="/creditRequests/AwaitingSupplier" exact render={() => <p>Under-development</p>} />
					<Route
						path="/transfers/incoming"
						exact
						render={(routeProps: RouteProps) => (
							<TransferListPage pageName="IncomingTransfers" pageTitle="Incoming Transfers" />
						)}
					/>
					<Route
						path="/transfers/outstandingVirtuals"
						exact
						render={(routeProps: RouteProps) => (
							<TransferListPage pageName="OutstandingVirtuals" pageTitle="Virtual Transfers" />
						)}
					/>
					<Route path="/transfers/:id" exact render={(routeProps: RouteProps) => <ReceiveTransfer />} />
					<Route
						path="/ASN"
						exact
						render={(routeProps: RouteProps) => <AsnSearch pageTitle="Advanced Shipping Notices" />}
					/>
					<Route path="/labels" exact render={() => <ProductLabels />} />
					<Route path="/tag-sheet-labels" exact render={() => <TagSheetLabels />} />
					<Route path="/outstandingEdiInvoices" exact component={OutstandingEdiByDate} />
					<Route path="/outstandingEdiInvoice" exact component={OutstandingEdiInvoiceDetails} />
				</Switch>
			</Router>
		);
	} else {
		return <NoAccess message="Your location is not yet enabled for the app, stay tuned!" />;
	}
};
